<template>
	<header :class="user ? 'h-u-t' : ''">
		<div class="bonus-modal" v-if="configSpesific.autoBonus">
					<Modal :isVisible="bonus_modal">
						<template slot="content">
							<div class="close-btn button primary" @click="bonus_modal = false;type = ''">
									<svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
							</div>
							<component is="RequestPage" :propType="type" />
						</template>
					</Modal>
				</div>
			<slot v-if="!isMobile">
				<div class="top">
						<div class="container">
							<div class="row">
								<div class="row-inc">
									<div class="flex">
										<ul class="links-2">
											<li><router-link :to="{ name: 'Affiliate'}">Ortaklık Programı</router-link></li>
											<li><a  class="button danger live-tv-btn" href="https://macvardi1.link/" target="_blank">
												<svg viewBox="0 0 512 512" xml:space="preserve"> <g> <path class="st0" d="M485.234,116.625H261.906l69.719-69.719c1.75-1.75,1.75-4.563,0-6.313l-17.422-17.438   c-1.734-1.75-4.563-1.75-6.297,0l-89.688,89.688l-89.656-89.688c-1.75-1.75-4.563-1.75-6.313,0l-17.438,17.438   c-1.75,1.75-1.75,4.563,0,6.313l69.75,69.719H26.766c-14.781,0-26.766,12-26.766,26.781v319.969   c0,14.781,11.984,26.781,26.766,26.781h458.469c14.781,0,26.766-12,26.766-26.781V143.406   C512,128.625,500.016,116.625,485.234,116.625z M383.594,421.188c0,8.531-6.906,15.438-15.422,15.438H66.844   c-8.531,0-15.438-6.906-15.438-15.438V191.875c0-8.531,6.906-15.438,15.438-15.438h301.328c8.516,0,15.422,6.906,15.422,15.438   V421.188z M473.188,333.813h-45.125v-45.125h45.125V333.813z M449.047,234.156c-13.906,0-25.172-11.281-25.172-25.188   s11.266-25.188,25.172-25.188s25.172,11.281,25.172,25.188S462.953,234.156,449.047,234.156z"/> </g> </svg>
												<span>Maç İzle</span></a>
											</li>
											<li class="discount-request-btn" v-if="configSpesific.autoBonus && !isMobile"><a  class="button primary discount-request-btn" data-title="Discount Al" @click="bonus_modal = true;type = 'discount'" href="javascript:;">
												<svg viewBox="0 0 1024 1024" class="icon" version="1.1"><path d="M694.59 511.92c-121.21 0-219.47 98.26-219.47 219.47s98.26 219.47 219.47 219.47 219.47-98.26 219.47-219.47-98.26-219.47-219.47-219.47z m0 365.79c-80.69 0-146.33-65.64-146.33-146.33 0-80.69 65.64-146.33 146.33-146.33 80.68 0 146.33 65.64 146.33 146.33 0 80.69-65.65 146.33-146.33 146.33z" fill="#0F1F3C"/><path d="M679.15 753.5l-58.41-51.62-36.32 41.1 99.84 88.27L806.9 690.14l-41.39-36zM200.01 814.55c-23.52-39.54-24.45-87.29-2.48-127.71L411.7 292.57h127.24l101.25 184.96 64.14-35.11-82.03-149.85h35.02v-73.14h-33.38l69.95-146.29H255.02l76.33 146.29H291.6v73.14h36.84l-195.2 359.34c-34.39 63.34-32.93 138.11 3.91 200.04s101.86 98.91 173.91 98.91H437.7v-73.14H311.06c-46.02-0.01-87.53-23.61-111.05-63.17z m175.68-668.26h202.14l-34.98 73.14H413.86l-38.17-73.14z"/></svg>
												<span>Discount Al</span></a>
											</li>
											
											<li class="bonus-request-btn" v-if="configSpesific.autoBonus && !isMobile"><a class="button success bonus-request-btn" data-title="Bonus Al" @click="bonus_modal = true;type = 'bonus'" href="javascript:;">
												<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 16 16" fill="none"><path d="M3 3V0H5C6.65685 0 8 1.34315 8 3C8 1.34315 9.34315 0 11 0H13V3H16V6H0V3H3Z" fill="#030708"/><path d="M1 8H7V15H1V8Z" fill="#030708"/><path d="M15 8H9V15H15V8Z" fill="#030708"/></svg>
												<span>Bonus Al</span></a>
											</li>
											<promoCode  v-if="user"></promoCode>
										</ul>
									</div>
									<div class="info">
										<div class="dropdown">
											<button class="button" style="text-transform:uppercase" @click="languageDropdown = !languageDropdown">
												<img :src="require('@/assets/images/lang/' + $i18n.locale + '.jpg')">
												{{ $i18n.locale }}
											</button>
											<transition name="slide-fade">
													<div class="dropdown-menu" v-if="languageDropdown">
															<ul>
																<li v-for="(item, key) in lang" :key="key" v-show="$i18n.locale != item"><a @click="$i18n.locale = item; $store.dispatch('language/setLanguage', item)" href="javascript:;">
																	<img :src="require('@/assets/images/lang/' + item + '.jpg')"> {{ item | ucFirst }}</a>
																</li>
															</ul>
													</div>
											</transition>
										</div>
										<ul>
											<li>
												<a target="_blank":href="'https://api.whatsapp.com/send?phone=' + (!_.isUndefined(social.whatsapp) ? social.whatsapp : '')">Whatsapp Destek</a>
												<a target="_blank"href="https://t.me/esbetdestek">Telegram Destek</a>
												<a target="_blank"href="https://forms.gle/axbiwymgTeVcoKvA9" class="success">Aranma Talebi</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
				</div>
				
				<div class="center">
					<div class="container">
						<div class="row">
							<div class="row-inc">
									<Logo/>
									<div class="right">
										<router-link :to="{ name: 'Promotions' }" type="button" class="button success">
											<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 16 16" fill="none"><path d="M3 3V0H5C6.65685 0 8 1.34315 8 3C8 1.34315 9.34315 0 11 0H13V3H16V6H0V3H3Z" fill="#030708"/><path d="M1 8H7V15H1V8Z" fill="#030708"/><path d="M15 8H9V15H15V8Z" fill="#030708"/></svg>
											Promosyonlar</router-link>
										<div class="user-row">
											<slot v-if="!user">
												<DesktopGuest/>
											</slot>
											<slot v-else>
												<DesktopUser/>
											</slot>
										</div>
									</div>
									<!-- <Menu/> -->
									<!-- <div class="user">
											<DesktopGuest :pages="pages" v-if="!user"/>
											<DesktopUser :pages="pages" v-if="user"/>
									</div> -->
							</div>
						</div>
					</div>
				</div>
				<div class="bottom">
					<div class="container">
						<div class="row">
							<div class="row-inc">
								<Menu/>
							</div>
						</div>
					</div>
				</div>
			</slot>
			<slot v-else>
				<div class="top-m">
					<div class="menu">
						<a href="javascript:;" class="nav" v-if="activePanel != 'left-panel'" @click="triggerPanel('left-panel')">
							<svg xmlns="http://www.w3.org/2000/svg" id="icons" viewBox="0 0 24 24"><g fill=""><path d="m17 11h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"/><path d="m20 5h-16a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2z"/><path d="m15 17h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></g></svg>
						</a>
						<a href="javascript:;" class="nav" v-if="activePanel == 'left-panel'" @click="triggerPanel('')">
							<svg x="0px" y="0px" viewBox="0 0 1792 1792" style="enable-background:new 0 0 1792 1792;" xml:space="preserve"> <path d="M1082.2,896.6l410.2-410c51.5-51.5,51.5-134.6,0-186.1s-134.6-51.5-186.1,0l-410.2,410L486,300.4  c-51.5-51.5-134.6-51.5-186.1,0s-51.5,134.6,0,186.1l410.2,410l-410.2,410c-51.5,51.5-51.5,134.6,0,186.1  c51.6,51.5,135,51.5,186.1,0l410.2-410l410.2,410c51.5,51.5,134.6,51.5,186.1,0c51.1-51.5,51.1-134.6-0.5-186.2L1082.2,896.6z"/> </svg>
						</a>
					</div>
					<Logo @click.native="triggerPanel('')"/>
					<div class="user">
						<div class="icon" v-if="user">
								<a href="javascript:;" v-if="activePanel != 'right-panel'" class="nav" @click="triggerPanel('right-panel')">
									<svg viewBox="0 0 24 24"> <title/> <g id="Complete"> <g id="user"> <g> <path d="M20,21V19a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/> <circle cx="12" cy="7" fill="none" r="4" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/> </g> </g> </g> </svg>
								</a>
								<a href="javascript:;" class="nav" v-if="activePanel == 'right-panel'" @click="triggerPanel('')">
									<svg x="0px" y="0px" viewBox="0 0 1792 1792" style="enable-background:new 0 0 1792 1792;" xml:space="preserve"> <path d="M1082.2,896.6l410.2-410c51.5-51.5,51.5-134.6,0-186.1s-134.6-51.5-186.1,0l-410.2,410L486,300.4  c-51.5-51.5-134.6-51.5-186.1,0s-51.5,134.6,0,186.1l410.2,410l-410.2,410c-51.5,51.5-51.5,134.6,0,186.1  c51.6,51.5,135,51.5,186.1,0l410.2-410l410.2,410c51.5,51.5,134.6,51.5,186.1,0c51.1-51.5,51.1-134.6-0.5-186.2L1082.2,896.6z"/> </svg>
								</a>
						</div>
						<div class="icon" v-if="!user">
								<router-link :to="{ name: 'Login'}" class="nav">
									<svg viewBox="0 0 24 24"> <title/> <g id="Complete"> <g id="user"> <g> <path d="M20,21V19a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/> <circle cx="12" cy="7" fill="none" r="4" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/> </g> </g> </g> </svg>
								</router-link>
						</div>
					</div>
				</div>
				<div class="guest" v-if='!user'>
					<router-link class="button secondary" :to="{ name : 'Login' }">
						<svg viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM12 20.5C13.784 20.5 15.4397 19.9504 16.8069 19.0112C17.4108 18.5964 17.6688 17.8062 17.3178 17.1632C16.59 15.8303 15.0902 15 11.9999 15C8.90969 15 7.40997 15.8302 6.68214 17.1632C6.33105 17.8062 6.5891 18.5963 7.19296 19.0111C8.56018 19.9503 10.2159 20.5 12 20.5Z"></path></svg>
						Giriş Yap
					</router-link>
					<router-link class="button primary" :to="{ name : 'Register' }">
						<svg version="1.1" id="Layer_1" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><path d="M93.1,325.8V139.6H46.5C20.9,139.6,0,160.5,0,186.2v279.3C0,491.1,20.9,512,46.5,512h279.3c25.7,0,46.5-20.9,46.5-46.5  v-46.5H186.2C134.8,418.9,93.1,377.2,93.1,325.8z M465.5,0H186.2c-25.7,0-46.5,20.9-46.5,46.5v279.3c0,25.7,20.9,46.5,46.5,46.5  h279.3c25.7,0,46.5-20.9,46.5-46.5V46.5C512,20.9,491.1,0,465.5,0z M442.2,209.5h-93.1v93.1h-46.5v-93.1h-93.1v-46.5h93.1V69.8h46.5  v93.1h93.1V209.5z"></path></svg>
						Kayıt Ol
					</router-link>
				</div>
			</slot>
	</header>
</template>
<script>
	import Menu from './Header/Menu'
	import Logo from './Header/Logo'
	import promoCode from './Header/promoCode'
	import RequestPage from './Header/Request.vue'
	import DesktopGuest from './Header/DesktopGuest'
	import DesktopUser from './Header/DesktopUser'
	export default{
		props:['activePanel'],
		data(){
			return{
				type: '',
				bonus_modal: false,
				isLogin: false,
				date : this.$moment(new Date()).format('DD-MM-YYYY HH:mm:ss'),
				languageDropdown : false,
			}
		},
		components:{
			Menu,
			Logo,
			DesktopGuest,
			RequestPage,
			promoCode,
			DesktopUser
		},
		computed:{
			configSpesific(){ 
				return this.$store.getters['special/getConfigSpesific']
			},
			social(){
				return this.$store.getters.getClientContent;
			},
			pages(){
				return _.filter(this.$store.getters.getClientPages, {header: 1});
			},
			lang(){
				return this.$store.getters.getLanguages;
			},
			user(){
				return this.$user();
			}
		},
		mounted(){
			setInterval(() => {
				this.date = this.$moment(new Date()).format('DD-MM-YYYY HH:mm:ss');
			}, 1000);
		},
		methods:{
				triggerPanel(panel){
					this.$emit('triggerPanel', panel)
				}
		}
	}
</script>